import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeBgIcon from '@wix/da-ds/pkg/Icons/24x24/ChangeBg';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { BiData } from '@wix/da-bi/pkg/events';
var EditBackgroundButton = function (_a) {
    var _b;
    var deviation = _a.deviation, currentBackgroundId = _a.currentBackgroundId, onInitialize = _a.onInitialize, showBackgroundPicker = _a.showBackgroundPicker, isBackgroundsPopupOpen = _a.isBackgroundsPopupOpen;
    var t = useTranslation().t;
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    var onClick = useCallback(function () {
        if (isBackgroundsPopupOpen) {
            return;
        }
        showBackgroundPicker(deviation);
    }, [deviation, isBackgroundsPopupOpen, showBackgroundPicker]);
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('deviation.backgrounds.change') },
        React.createElement(ActionBarEditButton, { onClick: onClick, biData: BiData({
                evid: 370,
                itemid: deviation.deviationId,
                typeid: getDeviationResourceType(deviation),
                background_id: currentBackgroundId,
                core_only: ((_b = deviation.background) === null || _b === void 0 ? void 0 : _b.isPremium) ? 1 : 0,
            }) },
            React.createElement(ActionBarIcon, { icon: ChangeBgIcon }))));
};
EditBackgroundButton.displayName = 'EditBackgroundButton';
export default EditBackgroundButton;
//# sourceMappingURL=EditBackgroundButton.js.map